import { render, staticRenderFns } from "./node-editor.vue?vue&type=template&id=bffda6aa"
import script from "./node-editor.ts?vue&type=script&lang=js&external"
export * from "./node-editor.ts?vue&type=script&lang=js&external"
import style0 from "./node-editor.vue?vue&type=style&index=0&id=bffda6aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports